import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import H from './components/H';
import I from './components/I';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import { Accessories } from '@/components/ProductCommon/accessories';
import { BundleList } from '@/components/ProductCommon/bundle-list';
import OtherList from '@/components/ProductCommon/OtherList';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';

const product: any = {
    jp: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_delta_delta_pro'],
    cn: ['product_ps_river_river_256', 'product_ps_delta_delta_2', 'product_sp_220w_bi_solar_panel'],
};

export default function Com() {
    const { useRouter, gloproductlist, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('wave2portableairconditioner');

    const otherProductData = getDetaileMoreProducts(gloproductlist, product[locale]);
    const accessoriesList = ['cn', 'kr'].includes(locale)
        ? ['wave2-add-on-battery']
        : // : locale === 'au'
          // ? ['wave2-add-on-battery', 'wave2-exhaust-ducts']
          ['wave2-add-on-battery', 'wave2-exhaust-ducts', 'wave2-bag'];
    const BundleLists: any = {
        us: ['wave2delta2', 'wave2deltamax', 'wave2deltapro'],
        au: ['wave2glacier', 'wave2deltamax', 'wave2deltapro'],
        kr: ['wave2EB', 'wave2EB160w'],
    };
    return (
        <>
            <B />
            <C />
            <D />
            <E />
            {/* <F /> */}
            {/* <G /> */}
            <H />
            <I />
            {/* <J /> */}
            <K />
            <L />
            <M />
            <N />
            <O />
            <P />
            <Q />
            {/* @ts-ignore */}
            {!['jp', 'sa'].includes(locale) && <Accessories list={accessoriesList} />}
            {!['cn', 'jp', 'sa'].includes(locale) && (
                <BundleList list={BundleLists[locale] || BundleLists.us} moreUrl={`https://${locale}.ecoflow.com/collections/smart-devices`} />
            )}
            {['cn', 'jp'].includes(locale) && <OtherList data={otherProductData} theme="black" />}
            {/* 0515版本陈琨要求在页面最底部加分开售卖发货文案 */}
            {['us', 'ca', 'de', 'fr', 'it', 'es', 'eu', 'uk', 'jp', 'br', 'mx', 'ph'].includes(locale) && (
                <p className="bottom-note">{t('detail.bottom_note')}</p>
            )}
        </>
    );
}
